import { LuigiThemingService } from '../service/luigiNodes/luigi-theming.service';
import { ActivatedRoute } from '@angular/router';

(function () {
  const originalSheets = document.adoptedStyleSheets || [];

  Object.defineProperty(document, 'adoptedStyleSheets', {
    get() {
      return originalSheets.map((e) => e);
    },

    set(newSheets) {
      (
        (newSheets || []).find(
          (sheet: any) =>
            sheet._ui5StyleId ===
            'data-ui5-theme-properties|@ui5/webcomponents-theming',
        ) || {}
      ).disabled = true;
      originalSheets.length = 0;
      originalSheets.push(...(newSheets || []));
    },
  });
})();

export function initTheme(
  luigiThemingService: LuigiThemingService,
  route: ActivatedRoute,
) {
  return async (): Promise<void> => {
    let forcedTheme: string | undefined = undefined;
    route.queryParams.subscribe((params) => {
      forcedTheme = params['sap-theme'];
      if (checkForcedTheme(forcedTheme, luigiThemingService)) {
        luigiThemingService.applyTheme(forcedTheme, false);
      }
    });
    const theme = await luigiThemingService.getStoredThemeOrDefault();
    if (checkForcedTheme(forcedTheme, luigiThemingService)) {
      return;
    }
    luigiThemingService.applyTheme(theme, false);
  };
}

export function checkForcedTheme(
  forcedTheme: string | undefined,
  luigiThemingService: LuigiThemingService,
) {
  return !!(
    forcedTheme && luigiThemingService.themeIsPartOfCoreThemes(forcedTheme)
  );
}
